// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-components-___DashboardTarget__label____f72u {
  user-select: none;
}
.src-styles-components-___DashboardTarget__checkbox___BmVgc {
  display: none;
}
.src-styles-components-___DashboardTarget__checkbox___BmVgc + span {
  font-size: 1.25em;
  vertical-align: middle;
  margin-right: 0.25em;
}
.src-styles-components-___DashboardTarget__checkbox___BmVgc + span > i {
  color: #4ca92f;
}
.src-styles-components-___DashboardTarget__checkbox___BmVgc + span > i:nth-child(2) {
  display: none;
}
.src-styles-components-___DashboardTarget__checkbox___BmVgc:checked + span > i:first-child {
  display: none;
}
.src-styles-components-___DashboardTarget__checkbox___BmVgc:checked + span > i:nth-child(2) {
  display: inline-block;
}
.src-styles-components-___DashboardTarget__target--link___pyZxT {
  font-size: 0.5em;
  line-height: 0.5em;
  margin-left: 0.5em;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/DashboardTarget.less"],"names":[],"mappings":"AAEA;EACE,iBAAA;AADF;AAIA;EACE,aAAA;AAFF;AAIE;EACE,iBAAA;EACA,sBAAA;EACA,oBAAA;AAFJ;AAGI;EAAQ,cAAA;AAAZ;AACI;EAAqB,aAAA;AAEzB;AACE;EAAmC,aAAA;AAErC;AADE;EACE,qBAAA;AAGJ;AACA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AACF","sourcesContent":["@import '../variables.less';\n\n.label {\n  user-select: none;\n}\n\n.checkbox {\n  display: none;\n\n  & + span {\n    font-size: 1.25em;\n    vertical-align: middle;\n    margin-right: 0.25em;\n    & > i { color: @color-main-green; }\n    & > i:nth-child(2) { display: none; }\n  }\n\n  &:checked + span > i:first-child { display: none; }\n  &:checked + span > i:nth-child(2) {\n    display: inline-block;\n  }\n}\n\n.target--link {\n  font-size: 0.5em;\n  line-height: 0.5em;\n  margin-left: 0.5em;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
export var label = `src-styles-components-___DashboardTarget__label____f72u`;
export var checkbox = `src-styles-components-___DashboardTarget__checkbox___BmVgc`;
var _1 = `src-styles-components-___DashboardTarget__target--link___pyZxT`;
export { _1 as "target--link" };
export default ___CSS_LOADER_EXPORT___;
